import React, { useEffect, useState, useRef } from 'react';
import { AnimatePresence, motion, Variants } from 'framer-motion';
interface HyperTextProps {
  text: string;
  duration?: number;
  framerProps?: Variants;
  className?: string;
  animateOnLoad?: boolean;
}
const alphabets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
const getRandomInt = (max: number) => Math.floor(Math.random() * max);
export function HyperText({
  text,
  duration = 800,
  framerProps = {
    initial: {
      opacity: 0,
      y: -10
    },
    animate: {
      opacity: 1,
      y: 0
    },
    exit: {
      opacity: 0,
      y: 3
    }
  },
  className,
  animateOnLoad = true
}: HyperTextProps) {
  const [displayText, setDisplayText] = useState(text.split(''));
  const [trigger, setTrigger] = useState(false);
  const interations = useRef(0);
  const isFirstRender = useRef(true);
  const triggerAnimation = () => {
    interations.current = 0;
    setTrigger(true);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      if (!animateOnLoad && isFirstRender.current) {
        clearInterval(interval);
        isFirstRender.current = false;
        return;
      }
      if (interations.current < text.length) {
        setDisplayText(t => t.map((l, i) => l === ' ' ? l : i <= interations.current ? text[i] : alphabets[getRandomInt(26)]));
        interations.current = interations.current + 0.1;
      } else {
        setTrigger(false);
        clearInterval(interval);
      }
    }, duration / (text.length * 10));
    return () => clearInterval(interval);
  }, [text, duration, trigger, animateOnLoad]);
  return <div className="flex flex-wrap scale-100 cursor-default pt-4 sm:pt-6 md:pt-8 pb-0 min-h-[100px] sm:min-h-[100px] md:min-h-[120px] px-4 sm:px-6 md:px-8 w-full justify-center items-center" onMouseEnter={triggerAnimation} data-id="element-77">
      <AnimatePresence mode="wait" data-id="element-78">
        <div className="flex flex-col sm:flex-row justify-center gap-x-4 gap-y-2" data-id="element-79">
          <div className="flex justify-center gap-x-4" data-id="element-80">
            <div className="flex" data-id="element-81">
              {text.split(' ')[0].split('').map((letter, letterIndex) => <motion.span key={`first-${letterIndex}`} className={`font-mono text-4xl sm:text-6xl md:text-7xl lg:text-8xl ${className || ''}`} {...framerProps} data-id="element-82">
                    {letter.toUpperCase()}
                  </motion.span>)}
            </div>
            <div className="flex" data-id="element-83">
              {text.split(' ')[1].split('').map((letter, letterIndex) => <motion.span key={`second-${letterIndex}`} className={`font-mono text-4xl sm:text-6xl md:text-7xl lg:text-8xl ${className || ''}`} {...framerProps} data-id="element-84">
                    {letter.toUpperCase()}
                  </motion.span>)}
            </div>
          </div>
          <div className="flex justify-center gap-x-4" data-id="element-85">
            <div className="flex" data-id="element-86">
              {text.split(' ')[2].split('').map((letter, letterIndex) => <motion.span key={`third-${letterIndex}`} className={`font-mono text-4xl sm:text-6xl md:text-7xl lg:text-8xl ${className || ''}`} {...framerProps} data-id="element-87">
                    {letter.toUpperCase()}
                  </motion.span>)}
            </div>
            <div className="flex" data-id="element-88">
              {text.split(' ')[3].split('').map((letter, letterIndex) => <motion.span key={`fourth-${letterIndex}`} className={`font-mono text-4xl sm:text-6xl md:text-7xl lg:text-8xl ${className || ''}`} {...framerProps} data-id="element-89">
                    {letter.toUpperCase()}
                  </motion.span>)}
            </div>
          </div>
        </div>
      </AnimatePresence>
    </div>;
}